export default "__VITE_ASSET__EU4vQGHF__"